module.exports = __webpack_public_path__ + "img/m_erweima.20afde1a.png";